import {GeneralAction} from '../../../@types/actions';
import {GET_EXTRA_SETTINGS} from '../../../constants/ExtraConstants';

export const GetSettingsAction = (template: string): GeneralAction<string> => ({
    type: GET_EXTRA_SETTINGS,
    payload: template
});
